<script lang="ts">
    import SearchInput from '../../shared/SearchInput.svelte';
    import Checkbox from '../../shared/Checkbox/Checkbox.svelte';
    import { filter } from '../../../stores/filter';
    import { _ } from 'svelte-i18n';
</script>

<div class="filter">
    <SearchInput
        placeholder={$_('Search by name')}
        query={$filter.maps.query}
        onChange={() => {}}
        onKeyup={query => {
            $filter.maps.query = query;
        }}
    />
</div>

<style>
    .filter {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 2px 0 10px 0;
        border: 1px solid var(--color-gray-300);
        border-radius: 0.5rem;
        column-gap: 10px;
    }
</style>
